/**
 * Photograph slide-in — pairs with assets/component-landing-reveal.css.
 *
 * Adds `.is-revealed` to every <img data-lp-reveal> once the file has loaded and the photograph is 200px inside the
 * viewport (live's lazysizes `data-expand="-200"`), which plays the slide the stylesheet starts it hidden for. A
 * photograph inside a hidden panel is not intersecting, so it slides the first time its panel is shown, as live's
 * does. Sections render without the attribute in the theme editor, so nothing here needs to follow section reloads.
 */
if (!window.landingReveal) {
  const reveal = (image) => {
    // Resolve the hidden start style first, or a cached image skips the transition
    getComputedStyle(image).opacity;
    image.classList.add('is-revealed');
    // The Slideshow banner brings its copy in after the photograph
    image.closest('.image-overlay-band--reveal-slideshow')?.classList.add('is-revealed');
  };

  const onIntersect = (entries, observer) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      const image = entry.target;
      observer.unobserve(image);

      if (image.complete) {
        reveal(image);
      } else {
        image.addEventListener('load', () => reveal(image), { once: true });
        image.addEventListener('error', () => reveal(image), { once: true });
      }
    }
  };

  window.landingReveal = new IntersectionObserver(onIntersect, { rootMargin: '-200px 0px' });

  for (const image of document.querySelectorAll('img[data-lp-reveal]')) {
    window.landingReveal.observe(image);
  }
}
